/**
 * RegisteredScreen route composition helper (R-20 / GC-P1-10).
 */
import type { ReactNode } from 'react';
import type { MasterScreenId } from '../../registry/masterScreenRegistry.types.js';
import { RegisteredScreen } from '../../shared/screen/RegisteredScreen.js';

export function withRegisteredScreen(screenId: MasterScreenId, element: ReactNode): JSX.Element {
  return <RegisteredScreen screenId={screenId}>{element}</RegisteredScreen>;
}
